import React from 'react';

const DeleteFuse = ({ modalInfo, handleCloseModal, handleDeleteFuse }) => {
  return (
    <div className="delete-modal-content">
      <p>
        Delete Fusion: {modalInfo.brand_name} + {modalInfo.celebrity_name}
      </p>
      <div className="delete-modal-buttons">
        <button
          className="btn btn--secondary-outline delete-modal-button"
          onClick={() => handleDeleteFuse(modalInfo.ID)}
        >
          Delete
        </button>
        <button
          className="btn btn--primary-outline delete-modal-button"
          onClick={handleCloseModal}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default DeleteFuse;
